// extracted by mini-css-extract-plugin
export default {"toplistContainer":"cw_kg","listContainer":"cw_kh","info":"cw_C"};